import Box from '@redbubble/design-system/src/Box';
import HighlightedTickIcon from '@redbubble/design-system/src/Icons/HighlightedTick';
import Text from '@redbubble/design-system/src/Text';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import styles from './EstablishedArtistCaption.module.scss';

interface EstablishedArtistCaptionProps {
  caption?: string;
}

const messages = defineMessages({
  establishedArtist: {
    defaultMessage: 'Established artist',
  },
});

export const EstablishedArtistCaption: React.FC<
  EstablishedArtistCaptionProps
> = ({ caption }) => {
  const intl = useIntl();

  return (
    <Box className={styles.caption}>
      <Text lineClamp={1} type="body2">
        {caption}
      </Text>
      <Box
        className={styles.establishedArtistIcon}
        data-testid="tick-icon"
        title={intl.formatMessage(messages.establishedArtist)}
      >
        <HighlightedTickIcon size="small" color="#0066ff" />
      </Box>
    </Box>
  );
};
